import PropTypes from 'prop-types';
import React, { Component } from 'react';

import BackButton from '@/components/BackButton';
import Breadcrumbs, { Breadcrumb } from '@/components/Breadcrumbs';
import Page from '@/components/Page';
import PageContent from '@/components/PageContent';
import PageHeader from '@/components/PageHeader';
import PageTitle from '@/components/PageTitle';
import PaperSheet from '@/components/PaperSheet';
import ProductNameLazy from '@/containers/ProductNameLazy';
import { ROUTE_PATH as PRODUCTS_PATH } from '@/features/productsPage/consts';

import Actions from './Actions';
import Description from './Description';

class Product extends Component {
  static propTypes = {
    isLoaded: PropTypes.bool.isRequired,
    itemId: PropTypes.string.isRequired,
  };

  render() {
    const { isLoaded, itemId } = this.props;

    if (!isLoaded) {
      return null;
    }

    return (
      <>
        <Page>
          <PageHeader gutterBottom={false}>
            <Breadcrumbs>
              <Breadcrumb to={PRODUCTS_PATH}>Товар</Breadcrumb>
            </Breadcrumbs>
            <BackButton />
            <PageTitle>
              <ProductNameLazy productId={itemId} />
            </PageTitle>
          </PageHeader>
          <PageContent>
            <PaperSheet>
              <Description productId={itemId} />
              <Actions />
            </PaperSheet>
          </PageContent>
        </Page>
      </>
    );
  }
}

export default Product;
